module.exports = "../images/hunting-activities-ear-falls-1@2x.jpg?v=e6a2460";